export class Routes {
  // get
  static impressions = (): string => "/api/admin/dashboard/impressions"
  static activity = (): string => "/api/admin/dashboard/activity"
  static mostActive = (): string => "/api/admin/dashboard/most-active"
}
